import React from 'react'
import {FancyCheckmark} from 'common/FancyCheckmark'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {CircleSpinner} from 'common/spinners/CircleSpinner'

export class PublishDialog extends React.PureComponent {
  render () {
    const {experience, closeDialog, shareAccessCode, publishPending} = this.props

    return (
      <ConfirmationDialog
        confirmText='Close'
        cancelText={publishPending ? null : 'Share Access Code'}
        onRequestClose={closeDialog}
        onCancel={publishPending ? null : shareAccessCode}
        onConfirm={closeDialog}>
        {!publishPending && <FancyCheckmark />}
        {publishPending && <div style={{textAlign: 'center'}}><CircleSpinner size={36} /></div>}
        <div style={{marginTop: '20px', textAlign: 'left'}}>
          <strong>{experience.name}</strong> is updating! This can take several minutes to process. Once this Experience is updated, you'll be able to share your access code.
        </div>
      </ConfirmationDialog>
    )
  }
}
